import type { FC, ReactNode } from 'react';
import clsx from 'clsx';

import Badge from '@trend-dev/trendtech-ui/components/UI/Badge';

import styles from './styles.module.scss';

interface Props {
    granted?: boolean;
    hint?: ReactNode;
}

const Hint: FC<Props> = ({ granted, hint }) => {
    return (
        <Badge
            className={clsx(styles.badge, {
                [styles.badgeGranted]: granted,
            })}
            kind=''
            content={hint}
        />
    );
};

export default Hint;
